import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
    selector: 'app-filter-list',
    templateUrl: './filter-list.component.html',
    styleUrls: ['./filter-list.component.scss'],
    standalone: false
})
export class FilterListComponent implements OnInit {
  @Input() public filterByTripId: string;
  @Input() public filterByDate: string;
  @Input() public pageName: string;
  public listpage: any;
  private pagefilter: any;
  constructor(
    private popoverCtrl: PopoverController
  ) { }

  public ngOnInit() {
    this.pagefilter = this.pageName;
  }
  public ngAfterViewInit() { }
  public close(sortBy) {
    if (sortBy == 'tripId') {
      this.filterByTripId =
        this.filterByTripId == 'tripidDescending'
          ? 'tripidAscending'
          : 'tripidDescending';
    } else if (sortBy == 'date') {
      if (this.pagefilter == 'trip') {
        this.filterByDate =
          this.filterByDate == 'tripDateDescending'
            ? 'tripDateAscending'
            : 'tripDateDescending';
      } else {
        this.filterByDate =
          this.filterByDate == 'invDateDescending'
            ? 'invDateAscending'
            : 'invDateDescending';
      }

    }
    this.popoverCtrl.dismiss({
      filteredBy: sortBy,
      filterByTripId: this.filterByTripId,
      filterByDate: this.filterByDate,
    });
  }
}
